export * from './message/constants';
export * from './chat/constants';
export * from './events/constants';
export * from './tasks/constants';

export enum TEMPLATE_HEADER_TYPE {
    TEXT = 'TEXT',
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
    DOCUMENT = 'DOCUMENT',
}

export const BOT_SESSION_ACTIONS = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    GET: 'GET',
};

export const BOT_SESSION_MESSAGE_ACTIONS = {
    UPDATE: 'UPDATE',
    GET: 'GET',
};
